import _clone from 'lodash/cloneDeep';
import _random from 'lodash/random';
import {
  LaidSlotsDropPayload,
  RecordState,
  DropFromSlotsToSlotsPayload,
  IDropFromSlotsToHomeAction,
  IDropFromLaidToHomeAction,
  IDropFromSlotsToLaidAction,
  IShowCardsOverflowMessage,
} from '../types';
import {
  getSuperMove,
  makeGameStep,
  getNumberOfEmptyPiles,
  getNumberOfEmptySlots,
  getCardsRenderInfo,
} from '../../utils';
import { getDropElements, makeHints } from '../../functions/hints';
import { makeState } from '../store';
import { Record } from 'immutable';

export function dropFromLaidToLaid(state: RecordState, action: any): RecordState {
  const newState = state.toJS();
  const prevGameState = state.get('gameState');

  const { gameState, numberOfEmptyPiles, numberOfEmptySlots, settings } = newState;
  const { laid, slots } = newState.gameState;
  const { pileOneNumber, pileTwoNumber, splitNumber, undoPosition } = action.payload;
  laid[pileTwoNumber] = laid[pileTwoNumber].concat(laid[pileOneNumber].splice(splitNumber, laid[pileOneNumber].length));

  settings.superMoveSequence = 0;
  //gameData.scores -= 2;
  //gameData.scores = Math.max(0, gameData.scores);

  makeGameStep(gameState);
  const dropElements = getDropElements(gameState);
  newState.numberOfEmptyPiles = getNumberOfEmptyPiles(laid);
  newState.numberOfEmptySlots = getNumberOfEmptySlots(slots);
  const hints = makeHints(dropElements, numberOfEmptyPiles, numberOfEmptySlots);
  newState.hintNumber = 0;

  newState.dropElements = dropElements;
  newState.hints = hints;
  const superMove = getSuperMove(dropElements, gameState);
  const listening = !Boolean(superMove);
  newState.settings.superMove = superMove;
  newState.settings.listening = listening;
  newState.history.push({
    state: prevGameState,
    action: _clone(action),
    undoPosition,
  });
  newState.gameData.steps++;

  return Record(newState)();
}

export function dropFromLaidToSlots(state: RecordState, action: LaidSlotsDropPayload | any): RecordState {
  const newState = state.toJS();
  const prevGameState = state.get('gameState');

  const { gameState, numberOfEmptyPiles, numberOfEmptySlots, settings, gameData } = newState;
  const { laid, slots } = gameState;
  const { slotNumber, pileNumber } = action.payload;

  slots[slotNumber] = laid[pileNumber].splice(-1)[0];

  settings.superMoveSequence = 0;
  gameData.scores -= 1;
  gameData.scores = Math.max(0, gameData.scores);

  makeGameStep(gameState);
  const dropElements = getDropElements(gameState);
  const hints = makeHints(dropElements, numberOfEmptyPiles, numberOfEmptySlots);
  newState.numberOfEmptyPiles = getNumberOfEmptyPiles(laid);
  newState.numberOfEmptySlots = getNumberOfEmptySlots(slots);

  newState.dropElements = dropElements;
  newState.hints = hints;
  const superMove = getSuperMove(dropElements, gameState);
  const listening = !Boolean(superMove);
  newState.settings.superMove = superMove;
  newState.settings.listening = listening;
  newState.history.push({
    state: prevGameState,
    action: _clone(action),
  });
  newState.gameData.steps++;

  return Record(newState)();
}

export function dropFromSlotsToSlots(state: RecordState, action: DropFromSlotsToSlotsPayload | any): RecordState {
  const newState = state.toJS();
  const prevGameState = state.get('gameState');
  const { gameState, numberOfEmptyPiles, numberOfEmptySlots, settings, gameData } = newState;
  const { slotOneNumber, slotTwoNumber } = action.payload;
  const { slots, laid } = gameState;

  settings.superMoveSequence = 0;
  gameData.scores -= 1;
  gameData.scores = Math.max(0, gameData.scores);

  slots[slotTwoNumber] = slots[slotOneNumber];
  slots[slotOneNumber] = null;

  makeGameStep(gameState);
  const dropElements = getDropElements(gameState);
  const hints = makeHints(dropElements, numberOfEmptyPiles, numberOfEmptySlots);
  newState.hintNumber = 0;
  newState.numberOfEmptyPiles = getNumberOfEmptyPiles(laid);
  newState.numberOfEmptySlots = getNumberOfEmptySlots(slots);

  newState.dropElements = dropElements;
  newState.hints = hints;
  newState.history.push({
    state: prevGameState,
    action: _clone(action),
  });
  newState.gameData.steps++;

  return Record(newState)();
}

export function dropFromSlotsToLaid(state: RecordState, action: IDropFromSlotsToLaidAction | any): RecordState {
  const newState = state.toJS();
  const prevGameState = state.get('gameState');
  const { gameState, numberOfEmptyPiles, numberOfEmptySlots, settings } = newState;
  const { laid, slots } = gameState;
  const { pileNumber, slotNumber } = action.payload;

  settings.superMoveSequence = 0;
  //gameData.scores -= 2;
  //gameData.scores = Math.max(0, gameData.scores);

  // @ts-ignore
  laid[pileNumber].push(slots[slotNumber]);
  slots[slotNumber] = null;

  makeGameStep(gameState);
  const dropElements = getDropElements(gameState);
  const hints = makeHints(dropElements, numberOfEmptyPiles, numberOfEmptySlots);
  newState.hintNumber = 0;
  newState.numberOfEmptyPiles = getNumberOfEmptyPiles(laid);
  newState.numberOfEmptySlots = getNumberOfEmptySlots(slots);

  newState.dropElements = dropElements;
  newState.hints = hints;
  const superMove = getSuperMove(dropElements, gameState);
  const listening = !Boolean(superMove);
  newState.settings.superMove = superMove;
  newState.settings.listening = listening;
  newState.history.push({
    state: prevGameState,
    action: _clone(action),
  });
  newState.gameData.steps++;

  return Record(newState)();
}

export function dropFromLaidToHome(state: RecordState, action: IDropFromLaidToHomeAction): RecordState {
  const newState = state.toJS();
  const prevGameState = state.get('gameState');
  const { gameState, numberOfEmptyPiles, numberOfEmptySlots, settings, gameData } = newState;

  if (Boolean(settings.superMove)) {
    settings.superMoveSequence++;
    settings.superMoveSequence = Math.min(settings.superMoveSequence, 3);
  } else {
    settings.superMoveSequence = 0;
  }

  gameData.scores += 5 * (settings.superMoveSequence || 1);

  const { laid, home, slots } = gameState;
  const { homeSlotNumber, pileNumber } = action.payload;

  home[homeSlotNumber] = home[homeSlotNumber].concat(laid[pileNumber].splice(-1));

  newState.gameData.cardsAtHome = home.reduce((acc: any, slot: any) => acc + slot.length, 0);
  if (newState.gameData.cardsAtHome === 52) newState.gameData.isWin = true;

  makeGameStep(gameState);
  const dropElements = getDropElements(gameState);
  const hints = makeHints(dropElements, numberOfEmptyPiles, numberOfEmptySlots);
  newState.hintNumber = 0;
  newState.numberOfEmptyPiles = getNumberOfEmptyPiles(laid);
  newState.numberOfEmptySlots = getNumberOfEmptySlots(slots);

  newState.dropElements = dropElements;
  newState.hints = hints;
  const superMove = getSuperMove(dropElements, gameState);
  const listening = !Boolean(superMove);
  newState.settings.superMove = superMove;
  newState.settings.listening = listening;
  newState.history.push({
    state: prevGameState,
    action: _clone(action),
  });
  newState.gameData.steps++;

  return Record(newState)();
}

export function dropFromSlotsToHome(state: RecordState, action: IDropFromSlotsToHomeAction) {
  const newState = state.toJS();
  const prevGameState = state.get('gameState');
  const { gameState, numberOfEmptyPiles, numberOfEmptySlots, settings, gameData } = newState;

  const { slots, home, laid } = gameState;
  const { homeSlotNumber, slotNumber } = action.payload;

  if (Boolean(settings.superMove)) {
    settings.superMoveSequence++;
    settings.superMoveSequence = Math.min(settings.superMoveSequence, 3);
  } else {
    settings.superMoveSequence = 0;
  }

  gameData.scores += 5 * (settings.superMoveSequence || 1);

  // @ts-ignore
  home[homeSlotNumber].push(slots[slotNumber]);
  slots[slotNumber] = null;

  makeGameStep(gameState);
  const dropElements = getDropElements(gameState);
  const hints = makeHints(dropElements, numberOfEmptyPiles, numberOfEmptySlots);
  newState.hintNumber = 0;
  newState.numberOfEmptyPiles = getNumberOfEmptyPiles(laid);
  newState.numberOfEmptySlots = getNumberOfEmptySlots(slots);

  newState.dropElements = dropElements;
  newState.hints = hints;
  const superMove = getSuperMove(dropElements, gameState);
  const listening = !Boolean(superMove);
  newState.settings.superMove = superMove;
  newState.settings.listening = listening;
  newState.history.push({
    state: prevGameState,
    action: _clone(action),
  });

  newState.gameData.steps++;
  newState.gameData.cardsAtHome = home.reduce((acc: any, slot: any) => acc + slot.length, 0);
  if (newState.gameData.cardsAtHome === 52) newState.gameData.isWin = true;

  return Record(newState)();
}

export function setListening(state: RecordState, listening: boolean) {
  const newState = state.toJS();

  newState.settings.listening = listening;

  return Record(newState)();
}

export function undo(state: RecordState): RecordState {
  const newState = state.toJS();

  const { history, numberOfEmptyPiles, numberOfEmptySlots } = newState;

  if (!history.length) return state;
  const step = history.pop();

  if (step) {
    newState.gameState = _clone(step.state);
    newState.gameData.steps++;
    newState.gameData.scores = Math.max(0, newState.gameData.scores - 10);

    makeGameStep(step.state);
    const dropElements = getDropElements(step.state);
    const hints = makeHints(dropElements, numberOfEmptyPiles, numberOfEmptySlots);
    newState.hintNumber = 0;
    newState.numberOfEmptyPiles = getNumberOfEmptyPiles(newState.gameState.laid);
    newState.numberOfEmptySlots = getNumberOfEmptySlots(newState.gameState.slots);

    newState.dropElements = dropElements;
    newState.hints = hints;
    const superMove = false;
    const listening = !Boolean(superMove);
    newState.settings.superMove = superMove;
    newState.settings.listening = listening;
  }

  return Record(newState)();
}

export function toggleModal(state: RecordState, name: string): RecordState {
  const newState = state.toJS();

  if (name === 'newGame' || name === 'restart' || name === 'rules') {
    const modal = newState.modals[name];
    modal.isVisible = !modal.isVisible;
  }

  return Record(newState)();
}

export function newGame(state: RecordState, id?: number): RecordState {
  const newState = makeState(id, true);
  const size = state.get('size');

  return newState
    .set('size', size)
    .set('orientation', state.get('orientation'))
    .set('cardsRenderInfo', getCardsRenderInfo(size));
}

export function restartGame(state: RecordState): RecordState {
  const id = state.get('id');
  return newGame(state, id);
}

export function showCardsOverflowMessage(state: RecordState, action: IShowCardsOverflowMessage): RecordState {
  const newState = state.toJS();
  newState.cardsOverflowMessage = {
    isVisible: action.payload.visible,
    maxCards: action.payload.maxCards,
    needCards: action.payload.needCards,
  };

  return Record(newState)();
}

export function increaseHintNumber(state: RecordState): RecordState {
  const newState = state.toJS();

  const { hints } = newState;
  newState.hintNumber++;
  if (newState.hintNumber >= hints.length) newState.hintNumber = 0;

  return Record(newState)();
}
